<template>
  <div :class="$style.container" v-if="meetings.length > 0">
    <ul :class="$style.contactList">
      <li v-for="activity in meetings" :key="activity.id" :class="$style.contactListItem">
        <span :class="$style.userImage">
          <span :class="$style.medium" :style="{borderColor: userImageBorder(activity.organizer)}">
            <img :src="activity.organizer.photoUrl || defaultAvatar"  />
          </span>
        </span>
        <span :class="$style.contactDetails">
            <h5>{{ activityTitle(activity) }}</h5>
          <template>
            <p><i>{{ activity.title }}</i></p>
          </template>
          <template v-if="activity.category">
            <i>{{ activity.category.name }}</i>
          </template>
          <p :class="$style.stage" v-if="activity.stage">{{ activity.stage.name }}</p>
        </span>
        <span :class="$style.actions">
          <p>{{ activity.scheduledDate }}</p>
          <p>{{ activity.scheduledStartTime }}</p>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
  import store from '@/lib/store'
  import { jiminnyHost } from '@/helpers/region'
  import moment from 'moment'
  import defaultAvatar from '@/assets/img/default-avatar.svg'
  import activityHelpers from '@/helpers/activity'

  export default {
    mixins: [activityHelpers],
    data () {
      return {
        meetings: [],
        dateFormat: 'YYYY-MM-DD HH:mm:ss',
        userId: store.get('user').id,
        defaultAvatar: defaultAvatar,
        language: window.navigator.language
      }
    },
    mounted () {
      this.getUpcomingMeetings()
    },
    methods: {
      getUpcomingMeetings () {
        this
          .retrieveMeetings()
          .then(activities => {
            this.meetings = activities
          })
      },
      getParams () {
        return {
          'user_id': [this.userId],
          'status': ['scheduled'],
          'scheduled_from': this.getStartDate(),
          'scheduled_to': this.getEndDate(),
          'sort_by': 'startTime',
          'sort_direction': 'asc',
          'exclude': ['stats']
        }
      },
      getStartDate () {
        return moment().utc().format(this.dateFormat)
      },
      getEndDate () {
        return moment().utc().add(1, 'month').format(this.dateFormat)
      },
      retrieveMeetings () {
        return this.$http
          .get(`${jiminnyHost()}/api/v1/activity/search`, {
            params: this.getParams()
          })
          .then(response => this.formatScheduledStartTime(response.data.results))
      },
      formatScheduledStartTime (activities) {
        return activities.map(activity => {
          const options = { month: 'numeric', day: 'numeric' }
          activity.scheduledDate = new Intl.DateTimeFormat(this.language, options).format(new Date(activity.scheduledStartTime))
          activity.scheduledStartTime = moment(activity.scheduledStartTime).format('HH:mm')
          return activity
        })
      },
      userImageBorder (user) {
        return user.group && user.group.color
      }
    }
  }
</script>

<style module lang="less" src="./upcoming-meeting.less"></style>



// WEBPACK FOOTER //
// upcoming-meeting.vue?0c963cf7